/**
 * Checks whether two DeviceInfo objects are the same.
 *
 * @param deviceA - The first device to compare.
 * @param deviceB - The second device to compare.
 * @return True if both devices are equal, false otherwise.
 */
export function areDevicesEqual(deviceA, deviceB) {
    if (!deviceA && !deviceB) {
        return true;
    }
    else if (!deviceA || !deviceB) {
        return false;
    }
    return (deviceA.id === deviceB.id &&
        deviceA.is_active === deviceB.is_active &&
        deviceA.is_controllable === deviceB.is_controllable &&
        deviceA.is_observable === deviceB.is_observable &&
        deviceA.local === deviceB.local &&
        deviceA.name === deviceB.name &&
        deviceA.type === deviceB.type &&
        deviceA.version === deviceB.version &&
        deviceA.volume === deviceB.volume);
}
export function areDeviceListsEqual(listA, listB) {
    if (!Array.isArray(listA) || !Array.isArray(listB)) {
        throw new TypeError('Invalid devices list.');
    }
    if (listA.length !== listB.length) {
        return false;
    }
    for (let i = 0, l = listA.length; i < l; i++) {
        if (!areDevicesEqual(listA[i], listB[i])) {
            return false;
        }
    }
    return true;
}
//# sourceMappingURL=device.js.map